import type { Theme, ThemeOptions } from '@mui/material'
import { darken, lighten } from '@mui/material'
import { isEmpty } from 'lodash'

import { calculateFlags } from '@acre/utils'

const disabledStates: CaseStatus[] = [
  'APPLICATION_SUBMITTED',
  'AWAITING_VALUATION',
  'AWAITING_OFFER',
  'OFFER_RECEIVED',
  'EXCHANGE',
  'COMPLETE',
]

export const areFieldsDisabled = (caseStatus: CaseStatus) =>
  (caseStatus && disabledStates.includes(caseStatus)) || false

export const renderDynamicTheme = (selectedColour: string, baseTheme: Theme) => {
  return {
    ...baseTheme,
    colours: {
      ...baseTheme.colours,
      primary: selectedColour,
      new: {
        ...baseTheme.colours.new,
      },
    },
    palette: {
      ...baseTheme.palette,
      primary: {
        main: selectedColour,
        light: lighten(selectedColour, 0.9),
        dark: darken(selectedColour, 0.4),
        contrastText: baseTheme.colours.new.white,
      },
    },
  } as ThemeOptions
}

export const mergeClientOriginatorAndCaseOwnerOrgFF = (
  clientOriginatorOrg: Maybe<Organisation>,
  caseOwnerOrg: Maybe<Organisation>,
) => {
  const clientOriginatorOrgFF = calculateFlags(clientOriginatorOrg)
  if (isEmpty(caseOwnerOrg?.metadata)) return clientOriginatorOrgFF

  const caseOwnerOrgFF = calculateFlags(caseOwnerOrg)

  // all feature flags are based on case owner org
  return caseOwnerOrgFF
}
